export default __webpack_public_path__ + "static/media/plus.b7e8a303.svg";